import React from 'react';
import { Alert, Row, Col } from 'antd';
import '../css/Login.scss';

const logo = require('../images/logo.svg');

export default function Unauthorized(props: any) {
    let url = props.location.pathname;
    let invalid = url[url.length - 1];
    console.log('url', url);
    return (
        <div className="Login">
            <div className="container">
                <Row>
                    <Col xs={2} sm={4} md={6} lg={8} xl={9}/>
                    <Col xs={20} sm={16} md={12} lg={8} xl={6}>
                    <div className="externalLogoContainer"><img className="logo" src={logo} /></div>
                    </Col>
                    <Col xs={2} sm={4} md={6} lg={8} xl={9}/>
                </Row>
                <div className="container">
                    <div className="linkExpired">
                        <Alert 
                            banner={true} 
                            message={'Unauthorized Access'}
                            description={invalid === '3' ?
                                'Test not recorded. Please contact EyeGuide administrator'
                                : 'Sorry we are unable to authenticate you. Please contact your EyeGuide provider'
                            }
                            type="error" 
                            showIcon={true} 
                        />
                    </div>
                </div>
            </div>
        </div>
    );
}


// WEBPACK FOOTER //
// ./src/components/unauthorized.tsx